
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anthropic-ui",
      function () {
        return require("private-next-pages/anthropic-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anthropic-ui"])
      });
    }
  